import { render, staticRenderFns } from "./ProductsSidebar.vue?vue&type=template&id=3acd8315&scoped=true"
import script from "./ProductsSidebar.vue?vue&type=script&lang=js"
export * from "./ProductsSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProductsSidebar.vue?vue&type=style&index=0&id=3acd8315&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3acd8315",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {VehicleSelectorButton: require('/app/components/VehicleSelectorButton.vue').default,CommercialOperationMenuEntry: require('/app/components/CommercialOperationMenuEntry.vue').default})
